import Fuse from 'fuse.js';

export const SEARCH_OPTIONS = {
  // Items are searched by their full ancestry path ("Category > Subcategory > Topic"), so a match on the item's own
  // name can start well past the front of the string. Fuse penalizes a match by its offset from `location` divided by
  // `distance` and discards anything scoring above `threshold`; the default distance of 100 would drop any match
  // starting past index 15. Keep distance far above the longest realistic path so position does not reject a match.
  distance: 10000,
  location: 0,
  keys: ['name'],
  shouldSort: true,
  threshold: 0.15,
};

export const INITIAL_RESULTS_LIMIT = 20;

/**
 * Creates a Fuse.js search instance with optimized settings for search menus
 * @param {Array} items - Array of items to search through
 * @param {Object} options - Optional custom Fuse.js options to override defaults
 * @returns {Fuse} Configured Fuse.js instance
 */
export function createSearchInstance(items, options = {}) {
  return new Fuse(items, { ...SEARCH_OPTIONS, ...options });
}
